import NS from './constants';

const getState = getter => (state) => {
  const curState = state && state.ui && state.ui[NS];
  if (curState) return getter(curState);
};

export const getOverlayNavIsOpen = getState(state => state.get('open'));
